import { ICategory } from './../../common/appDatabase';
import { CategoryType } from './../../common/enums';
import { IProduct } from '../../common/appDatabase';
import AppDatabase from "../../common/appDatabase";
import { ProductRelationFilterModel } from "../../models/product/productRelationFilterModel";
import { ProductModel } from "../../models/product/productModel";

class LocalProductsService {
    db = new AppDatabase();

    getFilteredProducts(filter: ProductRelationFilterModel) {
        return new Promise((resolve, reject) => {
            let products = new Array<ProductModel>();
            let searchTerm = filter.searchTerm ? filter.searchTerm.toLowerCase() : '';
            this.db.transaction('r', this.db.products, this.db.categories, async () => {
                let categories = await this.db.categories.toArray();
                let mainCategoryType = filter.isGasInstall ? CategoryType.GasInstallation : CategoryType.HeatInstallation;
                let categoriesToSearch = new Array<ICategory>();

                let mainCategory = categories.find(c => c.categoryTypeId === mainCategoryType);

                if (mainCategory) {
                    let subCategories = categories.filter(c => c.parentId === mainCategory?.remoteId);

                    if (subCategories) {

                        for (let i = 0; i < subCategories.length; i++) {
                            let currentCategory = subCategories[i];

                            filter.categoryTypes.forEach(categoryType => {
                                if (currentCategory.categoryTypeId === categoryType) {
                                    categoriesToSearch.push(currentCategory);
                                }

                                this.getChildCategories(currentCategory.remoteId, categories, categoriesToSearch, categoryType);
                            });
                        }
                    }
                }

                let dbProducts = await this.db.products.orderBy('article').filter((product) => {
                    if (categoriesToSearch.length > 0) {
                        if (categoriesToSearch.find(c => c.remoteId === product.categoryId)) {
                            return this.filterProduct(product, searchTerm);
                        } else {
                            return false;
                        }
                    } else {
                        return this.filterProduct(product, searchTerm);
                    }
                }).toArray();

                if (dbProducts) {
                    for (let i = 0; i < dbProducts.length; i++) {
                        let product = this.dbProductToProductModel(dbProducts[i]);
                        if (product) {
                            products.push(product);
                        }
                    }
                }

                products = products.sort((a, b) => (a.article?.toLowerCase() > b.article?.toLowerCase()) ? 1 : ((b.article?.toLowerCase() > a.article?.toLowerCase()) ? -1 : 0))
            }).then(
                () => {
                    resolve(products)
                }
            ).catch(err => {
                console.log(err);
                reject('Cannot get products from local db');
            });
        })
    }

    getAllProducts = () => {
        return new Promise((resolve, reject) => {
            this.db.transaction('r', this.db.products, async () => {
                this.db.products.toArray().then(
                    (products) => {
                        resolve(products)
                    }
                ).catch(error => {
                    reject(error);
                })
            })
                .catch(error => {
                    reject(error);
                });

        });
    }

    getProductsByRemoteId = (ids: Array<number>) => {
        return new Promise((resolve, reject) => {
            this.db.transaction('r', this.db.products, async () => {
                this.db.products.where('remoteId').anyOf(ids).toArray().then(
                    (products) => {
                        resolve(products);
                    }
                )
            })
                .catch(error => {
                    reject(error);
                });
        })
    }

    getProductImages = () => {
        return new Promise((resolve, reject) => {
            this.db.transaction('r', this.db.productImages, async () => {
                this.db.productImages.toArray().then(
                    (productImages) => {
                        resolve(productImages)
                    }
                ).catch(error => {
                    reject(error);
                })
            })
                .catch(error => {
                    reject(error);
                });

        });
    }

    private filterProduct = (product: IProduct, searchTerm: string): boolean => {
        if (!searchTerm) {
            return true
        }

        if (product.articleNumber.toLowerCase().includes(searchTerm)) {
            return true;
        }

        if (product.article && product.article.toLowerCase().includes(searchTerm)) {
            return true;
        }

        if (product.brand && product.brand.toLowerCase().includes(searchTerm)) {
            return true;
        }

        // if (product.power && product.power.toLowerCase().includes(searchTerm)) {
        //     return true;
        // }

        if (product.supplier && product.supplier.toLowerCase().includes(searchTerm)) {
            return true;
        }

        return false;
    }

    private getChildCategories = (id: number, categories: Array<ICategory>, result: Array<ICategory>, categoryType: CategoryType) => {
        let children = categories.filter(c => c.parentId === id);

        if (children) {
            for (let i = 0; i < children.length; i++) {
                if (children[i].categoryTypeId === categoryType) {
                    result.push(children[i]);
                }

                this.getChildCategories(children[i].remoteId, categories, result, categoryType);
            }
        }
    }

    private dbProductToProductModel(dbProduct: IProduct): ProductModel {
        return {
            productId: dbProduct.remoteId,
            categoryId: dbProduct.categoryId,
            articleNumber: dbProduct.articleNumber,
            unitId: dbProduct.unitId,
            article: dbProduct.article,
            supplier: dbProduct.supplier,
            brand: dbProduct.brand,
            power: dbProduct.power,
            secondPower: dbProduct.secondPower,
            model: dbProduct.model,
            price: dbProduct.price,
            priceFromSupplier: dbProduct.priceFromSupplier,
            discount: dbProduct.discount,
            description: dbProduct.description,
            isActive: dbProduct.isActive,
            relatedProducts: dbProduct.relatedProducts,
            category: dbProduct.category,
            fileId: dbProduct.fileId,
            diameter: dbProduct.diameter,
        }
    }
}

export default LocalProductsService